export class Validators {
  public Required (errorMessage: string) : any {
    return (value: any) => !!value || errorMessage
  }

  public RegEx (pattern: RegExp, errorMessage: string) : any {
    return (value: any) => {
      return pattern.test(value) || errorMessage
    }
  }
}
